import React from 'react';
import { Button, Tooltip } from 'antd';
import type { QuotationPrimaryCta } from '@/utils/quotationPrimaryCta';

type Props = {
  cta: QuotationPrimaryCta;
  loading?: boolean;
  onAction: (key: QuotationPrimaryCta['key']) => void;
};

export const QuotationPrimaryCtaButton: React.FC<Props> = ({ cta, loading, onAction }) => {
  if (cta.key === 'none') {
    return (
      <Tooltip title={cta.disabledReason}>
        <Button type="primary" disabled>
          {cta.label}
        </Button>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={cta.disabled ? cta.disabledReason : undefined}>
      <Button
        type="primary"
        loading={loading}
        disabled={cta.disabled}
        onClick={() => onAction(cta.key)}
      >
        {cta.label}
      </Button>
    </Tooltip>
  );
};

export default QuotationPrimaryCtaButton;
